import { createElement, forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../tokens/cn';
import type { VariantProps } from '../tokens/variants';
import { headingVariants, sizeToLevel, type HeadingLevel } from './heading.variants';

export type { HeadingLevel };

export interface HeadingProps
  extends Omit<HTMLAttributes<HTMLHeadingElement>, 'color'>,
    VariantProps<typeof headingVariants> {
  /** Semantic heading level. If omitted, derived from `size` (h1..h6). */
  as?: HeadingLevel;
}

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, size = 'h2', color, align, as, children, ...props }, ref) => {
    const level = as ?? sizeToLevel[size ?? 'h2'];
    return createElement(
      `h${level}`,
      {
        ref,
        className: cn(headingVariants({ size, color, align }), className),
        ...props,
      },
      children,
    );
  },
);

Heading.displayName = 'Heading';
